import React from 'react';
import PropTypes from 'prop-types';
import omit from 'lodash.omit';

import { buildSizes, buildSrcSet } from '../../../helper/index';

import StyledPicture from './picture.style';

const Picture = props => {
  const { sources = [], image } = props;
  return (
    <StyledPicture {...omit(props, ['sources', 'image'])}>
      {sources.map(source => (
        <source
          key={source.src}
          media={source.media ? source.media : null}
          srcSet={buildSrcSet(source.srcset)}
          sizes={source.sizes ? buildSizes(source.sizes) : null}
          type={source.mimeType ? source.mimeType : null}
        />
      ))}
      <img src={image.src} alt={image.alt} />
    </StyledPicture>
  );
};

Picture.propTypes = {
  sources: PropTypes.arrayOf(
    PropTypes.shape({
      srcset: PropTypes.arrayOf(
        PropTypes.shape({
          src: PropTypes.string,
          suffix: PropTypes.string
        })
      ),
      sizes: PropTypes.arrayOf(
        PropTypes.shape({
          condition: PropTypes.string,
          width: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        })
      ),
      media: PropTypes.string,
      mimeType: PropTypes.string
    })
  ),
  image: PropTypes.shape({
    src: PropTypes.string.isRequired,
    alt: PropTypes.string
  }).isRequired
};

export default Picture;
